import React from 'react';
import Layout from '../components/layout';
import AppPromoCodeShared from './app-promo-code/shared-component';
import SimpleFooter from '@components/simple-footer/simple-footer';

const AppPromoCode: React.FC = () => {
  return (
    <Layout showFooter={false}>
      <AppPromoCodeShared appName="" />
      <SimpleFooter />
    </Layout>
  );
};

export default AppPromoCode;